import { apiClient as api } from './api';
import type { StaffTask, PaginatedResult } from '../types/admin';

export type TaskScope = 'me' | 'none' | 'all';
export type TaskBucket = 'open' | 'overdue' | 'today' | 'upcoming' | 'undated' | 'done';
export type TaskCounts = Record<Exclude<TaskBucket, 'open'>, number>;
export interface DashboardSummary {
  actor: { id: number; name: string };
  counts: { overdue: number; today: number; support: number; development: number };
  assigned_support: { id: string; ticket_number: string; subject: string; priority: string }[];
  assigned_development: { id: number; title: string; priority: string }[];
}
export interface Attention {
  urgent_count: number;
  urgent_support: { id: string; ticket_number: string; subject: string; organization__name: string }[];
  customer_count: number;
  customers: { id: string; name: string; band: string; measured_on: string }[];
}
export interface ProductUpdate {
  id: number; title: string; pushed_at: string; time_estimated: boolean; sha: string;
  status: 'pushed' | 'staging' | 'production'; version: string;
  entries: { kind: string; text: string; path: string }[];
  commits: { sha: string; title: string }[];
  release_only: boolean; processing: boolean; compare_url: string; release_notes_url: string | null;
}
export interface UpdatesFeed {
  repository: string; branch: string; configured: boolean; last_synced_at: string | null;
  error: string; results: ProductUpdate[];
}
const timezone = () => Intl.DateTimeFormat().resolvedOptions().timeZone;
export const adminDashboardApi = {
  summary: async () => (await api.get<DashboardSummary>(`/api/admin/dashboard/summary/?timezone=${encodeURIComponent(timezone())}`)).data,
  tasks: async (scope: TaskScope, bucket: TaskBucket, page: number) => (await api.get<PaginatedResult<StaffTask> & { counts: TaskCounts }>(`/api/admin/dashboard/tasks/?${new URLSearchParams({ scope, bucket, page: String(page), page_size: '12', timezone: timezone() })}`)).data,
  attention: async () => (await api.get<Attention>('/api/admin/dashboard/attention/')).data,
  updates: async () => (await api.get<UpdatesFeed>('/api/admin/dashboard/updates/')).data,
};
